import { RecallTimingPreference, type RecallTimingPreference as RecallTimingPreferenceValue } from '@navio/nsdk';

/**
 * Sentinel for "no override". The API stores the automatic case as `null`, which a
 * select cannot hold, so the form carries this value instead.
 */
export const WHEEL_CHANGE_TIMING_AUTOMATIC = 'AUTOMATIC' as const;

export type WheelChangeTimingFormValue = typeof WHEEL_CHANGE_TIMING_AUTOMATIC | RecallTimingPreferenceValue;

/**
 * Declaration order is alphabetical (early, late, mid). Selects need seasonal order,
 * and the record makes a new preference fail compile until it has a place in that order.
 */
const timingPreferenceOrder = {
  [RecallTimingPreference.EARLY]: 0,
  [RecallTimingPreference.MID]: 1,
  [RecallTimingPreference.LATE]: 2
} satisfies Record<RecallTimingPreferenceValue, number>;

const timingFormValueOrder = (value: WheelChangeTimingFormValue) =>
  value === WHEEL_CHANGE_TIMING_AUTOMATIC ? -1 : timingPreferenceOrder[value];

export const wheelChangeTimingFormValues: WheelChangeTimingFormValue[] = [
  WHEEL_CHANGE_TIMING_AUTOMATIC,
  ...Object.values(RecallTimingPreference)
].sort((left, right) => timingFormValueOrder(left) - timingFormValueOrder(right));

export const toWheelChangeTimingFormValue = (
  overrideSegment: RecallTimingPreferenceValue | null | undefined
): WheelChangeTimingFormValue => overrideSegment ?? WHEEL_CHANGE_TIMING_AUTOMATIC;

export const fromWheelChangeTimingFormValue = (
  value: WheelChangeTimingFormValue
): RecallTimingPreferenceValue | null => (value === WHEEL_CHANGE_TIMING_AUTOMATIC ? null : value);
